import { AmountTier, TieredFeeTypeEnum } from '@inosio/payments-sdk';
import { Card, Grid, Modal, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import CancelIcon from '../../../icons/close.svg';
import RightArrow from '../../../icons/RightArrow.svg';

export interface CardsPricingModalProps {
  open: boolean;
  onClose: () => void;
  debitTiers: AmountTier[];
  CcPercentage: number;
  ccConvenienceFee?: number;
}
export default function CardsPricingModal(props: CardsPricingModalProps) {
  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    padding: '16px',
    height: '555px',
    pointerEvents: 'auto',
    width: '520px',
    borderRadius: '24px',
  };

  const parseTiers = (tiers: AmountTier[]): { fee: number; feeType: TieredFeeTypeEnum; low: number; high?: number }[] => {
    return tiers?.map((tier, index) => {
      return { fee: tier.Amount, low: tier.Floor === 0 ? 0 : tier.Floor + 1, high: tiers?.[index + 1]?.Floor, feeType: tier.FeeType };
    });
  };
  const parsedTiers = parseTiers(props.debitTiers);

  return (
    <Modal
      open={props.open}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      BackdropProps={{
        invisible: false,
      }}
      disableEscapeKeyDown
      disableAutoFocus={true}
    >
      <Card sx={style}>
        <Grid container width="100%" display="flex" justifyContent="center">
          <Grid item xs={12} display="flex" justifyContent="center">
            <Typography
              sx={{
                fontFamily: 'Work Sans !important',
                fontStyle: 'normal',
                fontWeight: '600',
                fontSize: '18px !important',
                lineHeight: '21px !important',
                color: '#14142B',
              }}
            >
              Card Pricing Details
            </Typography>
          </Grid>
          <TableContainer
            sx={{
              '.MuiTableCell-root': {
                textAlign: 'center',
                border: '1px solid #eeeeee',
              },
              width: '100%',
              display: 'flex',
              marginTop: '50px',
            }}
          >
            <Table sx={{ width: '30%' }}>
              <TableHead>
                <TableRow>
                  <TableCell
                    colSpan={1}
                    sx={{
                      fontFamily: 'Work Sans !important',
                      fontStyle: 'normal',
                      fontWeight: '600',
                      fontSize: '14px !important',
                      color: '#14142B',
                    }}
                  >
                    Credit Card
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>{`${(props.CcPercentage / 10).toFixed(1)}% +  $${((props.ccConvenienceFee as number) / 100).toFixed(2)}`}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    colSpan={2}
                    sx={{
                      fontFamily: 'Work Sans !important',
                      fontStyle: 'normal',
                      fontWeight: '600',
                      fontSize: '14px !important',
                      color: '#14142B',
                    }}
                  >
                    Debit Card
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {parsedTiers?.map((parsedTier, index) => {
                  return (
                    <TableRow key={index} sx={{ lineHeight: '20px', fontSize: '14px' }}>
                      <TableCell sx={{ paddingLeft: '2% !important', paddingRight: '2% !important', textAlign: 'center !important' }}>
                        {parsedTier.feeType === TieredFeeTypeEnum.P ? `${(+parsedTier.fee / 10).toFixed(1)}%` : `$${(+parsedTier.fee / 100).toFixed(2)}`}
                      </TableCell>
                      <TableCell>
                        {parsedTier.low === 0 ? `up to $${(+(parsedTier.high ?? 0) / 100).toFixed(0)}` : `$${+parsedTier.low / 100}`}
                        <img alt="rightArrow" src={RightArrow} style={{ marginLeft: '18px', marginRight: '18px', display: parsedTier.low === 0 || !parsedTier.high ? 'none' : '' }} />
                        {parsedTier.low === 0 ? '' : !parsedTier.high ? <span style={{ color: '#A2DBFA', fontSize: '16px', marginLeft: '8px' }}>+</span> : `${(+parsedTier.high / 100).toFixed(2)}`}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          {/* Close Icon */}
          <Grid item sx={{ position: 'absolute', top: 18, right: 20 }}>
            <img
              src={CancelIcon}
              alt="close"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                props.onClose();
              }}
            />
          </Grid>
        </Grid>
      </Card>
    </Modal>
  );
}
